import { P2GBox } from '@parcel2go/core-ui';
import { P2GButton } from '@parcel2go/core-ui';
import { P2GGrid } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  affected: number;
  confirm?: () => void;
  cancel?: () => void;
}

export default function ConfirmReturnCollection(props: props) {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  return (
    <P2GBox>
      <P2GText>
        {t('ARRANGE_RETURN_COLLECTION_TEXT', { defaultValue: 'Arrange a return collection for your selected items.' })}
      </P2GText>
      <P2GBox mt={2}>
        <P2GGrid container spacing={2}>
          {props.confirm && (
            <P2GGrid item>
              <P2GButton onClick={() => props.confirm()}>{t('SAVE_BUTTON', { defaultValue: 'Save' })}</P2GButton>
            </P2GGrid>
          )}
          {props.cancel && (
            <P2GGrid item>
              <P2GButton variant="primary" onClick={props.cancel}>
                {t('CANCEL_BUTTON', { defaultValue: 'Cancel' })}
              </P2GButton>
            </P2GGrid>
          )}
        </P2GGrid>
      </P2GBox>
    </P2GBox>
  );
}
